import {__} from "../util/dom"

export default function () {
    const circles = Array.from(__(".percent-circle"));
    circles.forEach(initCircle)
}

function circleFilledColour(circle) {
    return window.getComputedStyle(circle).backgroundColor;
}

function circleUnfilledColour(circle) {
    return window.getComputedStyle(circle).borderColor;
}

function circlePercent(circle) {
    return parseInt(circle.dataset.percent);
}

function percentToDegrees(percent) {
    return percent * 3.6; // unfactored: (percent * 360) / 100
}

function linearGradientString(degrees, firstColour, secondColour) {
    return `linear-gradient(${degrees}deg, ${firstColour} 50%, ${secondColour} 50%)`;
}

function circleGradient(circle, percent, filledColour, unfilledColour) {
    const degrees = percentToDegrees(percent);
    let firstGradientString = null;

    if(degrees <= 180) {
        firstGradientString = linearGradientString(degrees+90, "transparent", unfilledColour);
    }
    else {
        firstGradientString = linearGradientString(degrees-90, "transparent", filledColour);
    }

    return firstGradientString + ',' + linearGradientString(90, unfilledColour, "transparent");
}

function initCircle(circle) {
    const percent = circlePercent(circle);

    if(isNaN(percent)) {
        return;
    }

    const filledColour = circleFilledColour(circle);
    const unfilledColour = circleUnfilledColour(circle);
    const gradient = circleGradient(circle, percent, filledColour, unfilledColour);
    circle.style.backgroundImage = gradient;
}